module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Título":"Título"},"en":{"Título":"Title"},"ca":{"Título":"Títol"}}')
  delete Component.options._Ctor
}
